export const APP_NAME = 'goscope.net';
export const APP_NAME_SHORT = 'scope.net';
export const APP_URL = 'https://goscope.net';
export const MAINTAINER_NAME = 'Albert Kapitanov';
export const MAINTAINER_URL = 'https://github.com/kapitanov';
export const GITHUB_URL = 'https://github.com/kapitanov/goscope.net';
export const GITHUB_ISSUES_URL = `${GITHUB_URL}/issues`;

export const githubCommitUrl = (commitHash: string) => {
  return `${GITHUB_URL}/commit/${commitHash}`;
};

// Refer to https://icones.js.org/collection/all for icon names.
export const ICONS = {
  GITHUB: 'ph:github-logo',
  ARROW_RIGHT: 'ph:arrow-right',
  ARROW_LEFT: 'ph:arrow-left',
  COPY: 'ph:copy',
  COPY_OK: 'ph:check-square-offset',
  COPY_ERROR: 'ph:x-square-fill',
  PASTE: 'ph:clipboard',
  CLEAR: 'ph:trash',
  USE_EXAMPLE: 'ph:bookmark-simple',
  GO: 'ph:play-fill',
  RESET: 'ph:arrow-arc-left',
  CARET_DOWN: 'ph:caret-down-fill',
  QUESTION: 'ph:question',
  COPYRIGHT: 'ph:copyright',
  BETA: 'mdi:beta',
  X: 'ph:x',
  SHARE: 'ph:share-network',
  LINK: 'ph:link',
  EXPAND: 'mdi:arrow-expand-vertical',
  COLLAPSE: 'mdi:arrow-collapse-vertical',
  EXPAND_ROW: 'ph:plus-square',
  COLLAPSE_ROW: 'ph:minus-square',
  LIST_CHECKS: 'ph:list-checks',
  FUNNEL: 'ph:funnel',
  CHECK: 'ph:check',
  CHECK_SQUARE: 'ph:check-square',
  SQUARE: 'ph:square',
  TABLE: 'material-symbols:table',
  MARKDOWN: 'material-symbols:markdown-sharp',
  TEXT: 'material-symbols:text-format',
  CODE: 'material-symbols:code',

  GOLANG: 'tabler:brand-golang',
  GOPHER: 'logos:gopher',

  THEME_LIGHT: 'ph:sun',
  THEME_DARK: 'ph:moon',
  THEME_AUTO: 'ph:desktop',

  INSTALL: 'ph:download-simple'
};

export const listAllIcons = () => Object.values(ICONS);

export const HEAD = {
  title: APP_NAME,
  bodyAttrs: {
    class: 'bg-background text-foreground'
  },
  link: [
    // Favicon
    {
      rel: 'apple-touch-icon',
      sizes: '180x180',
      href: '/apple-touch-icon.png'
    },
    {
      rel: 'icon',
      type: 'image/png',
      sizes: '32x32',
      href: '/favicon-32x32.png'
    },
    {
      rel: 'icon',
      type: 'image/png',
      sizes: '16x16',
      href: '/favicon-16x16.png'
    },
    { rel: 'mask-icon', href: '/safari-pinned-tab.svg', color: '#0e7490' },

    // Sitemap
    {
      rel: 'sitemap',
      type: 'application/xml',
      title: 'Sitemap',
      href: '/sitemap.xml'
    }
  ],
  meta: [
    // App theme
    { name: 'theme-color', content: '#ffffff', media: '(prefers-color-scheme: light)' },
    { name: 'theme-color', content: '#202224', media: '(prefers-color-scheme: dark)' },
    { name: 'msapplication-TileColor', content: '#ffffff' }
  ]
};
